import uuid from 'uuid/v1'

export default [
  {
    id: uuid(),
    title: 'Dropbox',
    description:
      'Dropbox is a file hosting service that offers cloud storage, file synchronization, a personal cloud.',
    imageUrl:
      'https://aem.dropbox.com/cms/content/dam/dropbox/www/en-us/branding/app-dropbox-android@2x.png',
    totalDownloads: '594',
    updatedAt: '27/03/2019'
  },
  {
    id: uuid(),
    title: 'Medium Corporation',
    description:
      'Medium is an online publishing platform developed by Evan Williams, and launched in August 2012.',
    imageUrl: 'https://miro.medium.com/max/390/1*emiGsBgJu2KHWyjluhKXQw.png',
    totalDownloads: '625',
    createdAt: '31/03/2019'
  },
  {
    id: uuid(),
    title: 'Slack',
    description:
      'Slack is a cloud-based set of team collaboration tools and services, founded by Stewart Butterfield.',
    imageUrl:
      'https://slackhq.com/wp-content/uploads/2019/01/2019-01_BrandRefresh_slack-brand-refresh_header-1.png?w=460',
    totalDownloads: '857',
    createdAt: '03/04/2019'
  },
  {
    id: uuid(),
    title: 'Lyft',
    description:
      'Lyft is an on-demand transportation company based in San Francisco, California.',
    imageUrl:
      'https://1000logos.net/wp-content/uploads/2017/11/symbol-Lyft.jpg',
    totalDownloads: '406',
    createdAt: '04/04/2019'
  },
  {
    id: uuid(),
    title: 'GitHub',
    description:
      'GitHub is a web-based hosting service for version control of code using Git.',
    imageUrl:
      'https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png',
    totalDownloads: '835',
    createdAt: '04/04/2019'
  },
  {
    id: uuid(),
    title: 'Squarespace',
    description:
      'Squarespace provides software as a service for website building and hosting. Headquartered in NYC.',
    imageUrl:
      'https://static1.squarespace.com/static/5134cbefe4b0c6fb04df8065/t/5bd1e1d6c830250c199dde71/1540481500732/squarespace-logo-tertiary-white.jpg',
    totalDownloads: '835',
    createdAt: '04/04/2019'
  }
]
